import { render } from "./CurriculumEdit.vue?vue&type=template&id=2a35a1a7&scoped=true&ts=true"
import script from "./CurriculumEdit.vue?vue&type=script&lang=ts"
export * from "./CurriculumEdit.vue?vue&type=script&lang=ts"

import "./CurriculumEdit.vue?vue&type=style&index=0&id=2a35a1a7&scoped=true&lang=scss"

import exportComponent from "C:\\Users\\y-tosa.LOCALPSC\\repo\\seto-solan\\apps\\admin-app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2a35a1a7"]])

export default __exports__